
export const paginate = (data, rowsPerPage) => {
  const result = {};
  const pages = Math.ceil(data.length / rowsPerPage);
  let previous = 0;
  for (let page=1; page<=pages; page++) {
    result[page] = data.filter((d, i) => i > previous && i <= page * rowsPerPage);
    previous += rowsPerPage;
  }
  return result;
};


// WEBPACK FOOTER //
// ./src/modules/charts/functions.js